const local_url = "http://localhost:4000";
const remote_url = process.env.REACT_APP_REMOTE_URL;
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_url = remote_url;
export const pcp_role_id = "3f333df6-90a4-4fda-8dd3-9485d27cee37";
